module.exports = {
  'from_start': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 28.57,
      vol: 2.88,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 39.18,
      vol: 3.51,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 47.46,
      vol: 4.27,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 49.87,
      vol: 5.15,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 65.28,
      vol: 5.77,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 95.45,
      vol: 7.38,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 111.03,
      vol: 8.25,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 128.66,
      vol: 9.22,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 144.79,
      vol: 10.15,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 170.68,
      vol: 11.55,
      PMR: null,
      PME: null
    }
  ],

  'from_start_yearly': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 2.66,
      vol: 2.88,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 3.24,
      vol: 3.51,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 3.82,
      vol: 4.27,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 4.31,
      vol: 5.15,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 4.97,
      vol: 5.77,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 6.68,
      vol: 7.38,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 7.47,
      vol: 8.25,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 8.30,
      vol: 9.22,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 9.02,
      vol: 10.15,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 9.78,
      vol: 11.55,
      PMR: null,
      PME: null
    }
  ],

  'one_year': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 5.30,
      vol: 2.97,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 6.37,
      vol: 3.45,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 7.24,
      vol: 4.01,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 8.70,
      vol: 4.68,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 10.53,
      vol: 5.31,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 12.45,
      vol: 6.60,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 13.55,
      vol: 7.22,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 14.85,
      vol: 8.02,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 16.28,
      vol: 8.71,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 17.87,
      vol: 9.47,
      PMR: null,
      PME: null
    }
  ],

  'three_years': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 16.61,
      vol: 3.07,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 19.28,
      vol: 3.67,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 21.36,
      vol: 4.34,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 24.94,
      vol: 5.07,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 27.73,
      vol: 5.71,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 33.30,
      vol: 7.29,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 36.42,
      vol: 8.01,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 40.08,
      vol: 8.87,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 43.83,
      vol: 9.68,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 47.62,
      vol: 10.59,
      PMR: null,
      PME: null
    }
  ],

  'five_years': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 14.63,
      vol: 3.26,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 17.41,
      vol: 3.94,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 18.74,
      vol: 4.62,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 21.52,
      vol: 5.27,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 23.55,
      vol: 5.84,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 34.98,
      vol: 7.58,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 38.98,
      vol: 8.37,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 44.20,
      vol: 9.28,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 48.62,
      vol: 10.13,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 54.91,
      vol: 11.16,
      PMR: null,
      PME: null
    }
  ],

  '2016': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 0.95,
      vol: 1.56,
      PMR: -2.55,
      PME: -4.50
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 2.62,
      vol: 2.21,
      PMR: -3.15,
      PME: -5.36
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 3.91,
      vol: 2.80,
      PMR: -3.91,
      PME: -6.66
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 4.52,
      vol: 3.49,
      PMR: -4.22,
      PME: -7.10
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 7.42,
      vol: 4.27,
      PMR: -5.09,
      PME: -8.41
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 7.75,
      vol: 5.25,
      PMR: -6.69,
      PME: -11.32
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 8.65,
      vol: 6.01,
      PMR: -7.84,
      PME: -13.14
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 9.15,
      vol: 6.76,
      PMR: -9.32,
      PME: -15.04
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 10.76,
      vol: 7.27,
      PMR: -10.25,
      PME: -16.47
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 12.49,
      vol: 8.64,
      PMR: -12.05,
      PME: -19.38
    }
  ],

  '2017': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 2.19,
      vol: 1.20,
      PMR: -0.69,
      PME: -2.53
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 2.69,
      vol: 1.58,
      PMR: -0.93,
      PME: -3.39
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 3.53,
      vol: 1.99,
      PMR: -1.09,
      PME: -4.31
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 3.60,
      vol: 2.20,
      PMR: -1.23,
      PME: -4.80
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 4.46,
      vol: 2.99,
      PMR: -1.79,
      PME: -5.86
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 6.53,
      vol: 3.79,
      PMR: -2.23,
      PME: -7.51
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 7.14,
      vol: 4.33,
      PMR: -2.68,
      PME: -8.63
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 8.16,
      vol: 4.84,
      PMR: -2.99,
      PME: -9.67
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 8.94,
      vol: 5.22,
      PMR: -3.26,
      PME: -10.50
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 10.23,
      vol: 5.90,
      PMR: -3.52,
      PME: -12.15
    }
  ],

  '2018': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: -1.14,
      vol: 2.57,
      PMR: -2.55,
      PME: -4.50
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: -1.42,
      vol: 3.25,
      PMR: -3.15,
      PME: -5.36
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: -1.85,
      vol: 4.09,
      PMR: -3.91,
      PME: -6.66
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: -2.14,
      vol: 4.37,
      PMR: -4.22,
      PME: -7.10
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: -2.34,
      vol: 5.41,
      PMR: -5.09,
      PME: -8.41
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: -3.38,
      vol: 7.13,
      PMR: -6.69,
      PME: -11.32
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: -4.05,
      vol: 8.23,
      PMR: -7.84,
      PME: -13.14
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: -4.93,
      vol: 9.37,
      PMR: -9.32,
      PME: -15.04
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: -5.71,
      vol: 10.18,
      PMR: -10.25,
      PME: -16.47
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: -7.06,
      vol: 11.90,
      PMR: -12.05,
      PME: -19.38
    }
  ],

  '2019': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 4.20,
      vol: 1.18,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 5.55,
      vol: 1.51,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 6.88,
      vol: 1.98,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 8.15,
      vol: 2.53,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 8.98,
      vol: 3.11,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 11.21,
      vol: 3.99,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 12.78,
      vol: 4.67,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 14.48,
      vol: 5.28,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 15.95,
      vol: 5.91,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 18.02,
      vol: 6.74,
      PMR: null,
      PME: null
    }
  ],

  '2020': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 5.59,
      vol: 3.73,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 6.20,
      vol: 5.21,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 7.38,
      vol: 6.66,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 8.17,
      vol: 8.7,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 8.50,
      vol: 9.99,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 9.07,
      vol: 12.27,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 10.03,
      vol: 13.80,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 11.07,
      vol: 15.46,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 11.87,
      vol: 17.44,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 13.10,
      vol: 19.51,
      PMR: null,
      PME: null
    }
  ],

  '2021': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 3.36,
      vol: 2.03,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 4.66,
      vol: 2.65,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 5.70,
      vol: 3.33,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 6.58,
      vol: 3.85,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 6.96,
      vol: 4.17,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 12.72,
      vol: 5.81,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 14.54,
      vol: 6.47,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 16.47,
      vol: 7.2,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 18.3,
      vol: 7.93,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 20.98,
      vol: 8.92,
      PMR: null,
      PME: null
    }
  ],

  '2022': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: -5.98,
      vol: 4.33,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: -7.29,
      vol: 5.22,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: -8.56,
      vol: 5.99,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: -9.63,
      vol: 6.62,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: -10.56,
      vol: 7.16,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: -11.02,
      vol: 9.35,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: -12.05,
      vol: 10.35,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: -12.8,
      vol: 11.48,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: -13.6,
      vol: 12.45,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: -14.39,
      vol: 13.81,
      PMR: null,
      PME: null
    }
  ],

  '2023': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 5.74,
      vol: 2.94,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 7.06,
      vol: 3.51,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 7.67,
      vol: 3.99,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 8.35,
      vol: 4.30,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 8.89,
      vol: 4.69,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 12.21,
      vol: 6.79,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 13.68,
      vol: 7.53,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 15.28,
      vol: 8.38,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 16.24,
      vol: 9.27,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 18.24,
      vol: 10.27,
      PMR: null,
      PME: null
    }
  ],

  '2024': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 6.17,
      vol: 2.63,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 7.2,
      vol: 3.15,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 7.9,
      vol: 3.76,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 9.18,
      vol: 4.44,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 9.89,
      vol: 5,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 12.08,
      vol: 6.23,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 13.15,
      vol: 6.87,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 14.06,
      vol: 7.59,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 15.45,
      vol: 8.37,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 16.38,
      vol: 9.11,
      PMR: null,
      PME: null
    }
  ],

  '2025': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 5.20,
      vol: 3.05,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 5.75,
      vol: 3.80,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 6.37,
      vol: 4.72,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 7.17,
      vol: 5.73,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 7.57,
      vol: 6.45,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 9.09,
      vol: 8.20,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 9.77,
      vol: 9.05,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 10.94,
      vol: 10.06,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 11.79,
      vol: 10.90,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 12.83,
      vol: 12.04,
      PMR: null,
      PME: null
    }
  ],

  '2026': [
    {
      name: "Défensif 1",
      composition: "45% \u20ac<br> 55% UC",
      perf: 1.60,
      vol: 3.56,
      PMR: null,
      PME: null
    },
    {
      name: "Défensif 2",
      composition: "40% \u20ac<br> 60% UC",
      perf: 2.15,
      vol: 4.03,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 1",
      composition: "35% \u20ac<br> 65% UC",
      perf: 2.49,
      vol: 4.55,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 2",
      composition: "30% \u20ac<br> 70% UC",
      perf: 3.26,
      vol: 5.19,
      PMR: null,
      PME: null
    },
    {
      name: "Équilibré 3",
      composition: "25% \u20ac<br> 75% UC",
      perf: 4.47,
      vol: 5.92,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 1",
      composition: "20% \u20ac<br> 80% UC",
      perf: 5.34,
      vol: 7.22,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 2",
      composition: "15% \u20ac<br> 85% UC",
      perf: 5.91,
      vol: 7.82,
      PMR: null,
      PME: null
    },
    {
      name: "Offensif 3",
      composition: "10% \u20ac<br> 90% UC",
      perf: 6.56,
      vol: 8.63,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 1",
      composition: "5% \u20ac<br> 95% UC",
      perf: 7.20,
      vol: 9.39,
      PMR: null,
      PME: null
    },
    {
      name: "Agressif 2",
      composition: "0% \u20ac<br> 100% UC",
      perf: 8.01,
      vol: 10.07,
      PMR: null,
      PME: null
    }
  ]
};
